import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { API } from "../../assets/staticData";
import { Autocomplete, TextField } from "@mui/material";

export default function SelectPost({ post, setPost, ind }) {
  const [posts, setPosts] = React.useState([]);

  let userToken = localStorage.getItem("userToken");

  const headers = {
    Authorization: `Bearer ${userToken}`,
  };

  React.useEffect(() => {
    async function getData() {
      fetch(`${API}/articles?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setPosts(respone.data);
      });
    }

    getData();
  }, []);

  return (
    <FormControl
      sx={{ minWidth: 300, width: "90%", textAlign: "start" }}
      size="small"
    >
      <Autocomplete
        disablePortal
        disableClearable
        forcePopupIcon={false}
        selectOnFocus
        size="small"
        id="combo-box-demo"
        options={posts}
        getOptionKey={(option) => option.id}
        getOptionLabel={(option) => option.attributes.title}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        sx={{}}
        renderInput={(params) => (
          <TextField {...params} label="Select Article" sx={{ fontSize: 15 }} />
        )}
        onChange={(event, newValue) => {
          if (newValue) {
            setPost([
              ...post.map((item, idx) => {
                if (idx === ind) {
                  return {
                    ...item,
                    post: newValue,
                  };
                } else {
                  return item;
                }
              }),
            ]);
          }
        }}
      />
    </FormControl>
  );
}
